import en from "./en.json";
import lv from "./lv.json";
import ru from "./ru.json";

export type Locale = "en" | "lv" | "ru";

const translations: Record<Locale, Record<string, string>> = { en, lv, ru };

export function normalizeLocale(raw: string): Locale {
  const lower = raw.toLowerCase();
  if (lower.startsWith("ru")) return "ru";
  if (lower.startsWith("lv")) return "lv";
  return "en";
}

export function detectLocale(): Locale {
  // 1. localStorage preference
  const stored = localStorage.getItem("locale_preference");
  if (stored && ["en", "lv", "ru"].includes(stored)) return stored as Locale;

  // 2. browser languages
  const langs = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const lang of langs) {
    if (!lang) continue;
    const normalized = normalizeLocale(lang);
    if (normalized !== "en") return normalized;
    // Check if explicitly English
    if (lang.toLowerCase().startsWith("en")) return "en";
  }

  return "en";
}

export function t(
  key: string,
  locale: Locale,
  vars?: Record<string, string>
): string {
  let str =
    translations[locale]?.[key] ??
    translations["en"]?.[key] ??
    key;

  if (vars) {
    Object.entries(vars).forEach(([k, v]) => {
      str = str.replace(new RegExp(`{{${k}}}`, "g"), v);
    });
  }

  return str;
}
